export enum UserSecurityQuestionsEnum {
  MOTHER_MAIDEN_NAME = 'MOTHER_MAIDEN_NAME',
  CHILDHOOD_NICKNAME = 'CHILDHOOD_NICKNAME',
  OLDEST_SIBLING_MIDDLE_NAME = 'OLDEST_SIBLING_MIDDLE_NAME',
  FIRST_JOB_TOWN = 'FIRST_JOB_TOWN',
  CHILD_DREAM_JOB = 'CHILD_DREAM_JOB',
  GRANDMOTHERS_FIRST_NAME = 'GRANDMOTHERS_FIRST_NAME',
  FAVOURITE_MOVIE = 'FAVOURITE_MOVIE',
  FAVOURITE_PET_NAME = 'FAVOURITE_PET_NAME',
  FIRST_PHONE_MODEL = 'FIRST_PHONE_MODEL',
  FAVOURITE_PIZZA_TOPPING = 'FAVOURITE_PIZZA_TOPPING'
}
